import React, { useState, useEffect } from "react";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { updateUser } from "api/requests/updateUser";
import { deleteUser } from "api/requests/deleteUser";
// Chakra imports
import {
  Badge,
  Box,
  Checkbox,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Grid,
  Stack,
  Switch,
  Text,
  useToast,
  ModalHeader,
  useColorModeValue,
} from "@chakra-ui/react";

import useAuth from "hooks/useAuth";

import { BsCircleFill } from "react-icons/bs";
import { adminUpdateUser } from "api/requests/adminUpdateUser";

function UserModal({
  user,
  onOpen,
  onClose,
  isOpen,
  loggedInUser,
  onUserUpdate,
}) {
  const [scrollBehavior, setScrollBehavior] = React.useState("inside");
  // colors
  const bgColor = useColorModeValue("white", "#4A5058");
  const textColor = useColorModeValue("gray.600", "white");

  const toast = useToast();
  const [selectedRole, setSelectedRole] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [show, setShow] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [userData, setUserData] = useState(user);
  const [pwData, setPwData] = useState(user);
  const [originalData] = useState({ ...user });
  const axiosPrivate = useAxiosPrivate();
  const { auth, hasRequiredRole } = useAuth();

  const rolesList = {
    User: {
      value: true,
      description: "Test Description.",
      color: "green",
    },
    Rep: {
      value: user ? user?.roles?.Rep : false,
      description: "Test Description.",
      color: "pink",
    },
    Support: {
      value: user ? user?.roles?.Support : false,
      description: "Test Description.",
      color: "navy",
    },
    Creative: {
      value: user ? user?.roles?.Creative : false,
      description: "Test Description.",
      color: "teal",
    },
    Billing: {
      value: user ? user?.roles?.Billing : false,
      description: "Test Description.",
      color: "cyan",
    },
    Search: {
      value: user ? user?.roles?.Search : false,
      description: "Test Description.",
      color: "yellow",
    },
    Social: {
      value: user ? user?.roles?.Social : false,
      description: "Test Description.",
      color: "blue",
    },
    Manager: {
      value: user ? user?.roles?.Manager : false,
      description: "Test Description.",
      color: "orange",
    },
    Admin: {
      value: user ? user?.roles?.Admin : false,
      description: "Test Description.",
      color: "red",
    },
    SuperAdmin: {
      value: user ? user?.roles?.SuperAdmin : false,
      description: "Test Description.",
      color: "purple",
    },
    Dev: {
      value: user ? user?.roles?.Dev : false,
      description: "Test Description.",
      color: "gray",
    },
  };

  const handleClick = () => setShow(!show);

  const handleAccountStatus = async () => {
    const updatedField = {
      isActive: !user?.isActive,
    };
    const response = await updateUser(axiosPrivate, updatedField, user._id);
    console.log(response);
    if (response.status === 200) {
      toast({
        title: "Success!",
        description: `Profile has been ${
          response?.data?.isActive ? "Activated" : "Deactivated"
        }.`,
        status: "success",
        duration: 2000,
      });
      onUserUpdate();
    }
  };

  const saveChanges = async () => {
    const updatedFields = { roles: { ...roleCheckboxes } };
    // Object.keys(userData).forEach((key) => {
    //   if (userData[key] !== originalData[key]) {
    //     updatedFields[key] = userData[key];
    //   }
    // });
    console.log(updatedFields);
    const response = await updateUser(axiosPrivate, updatedFields, user._id);
    if (response.status === 200) {
      toast({
        title: "Success!",
        description: "Profile update saved.",
        status: "success",
        duration: 2000,
      });
      onUserUpdate();
    } else if (response.status === 400) {
      toast({
        title: "Error!",
        description: `Current password is incorrect.`,
        status: "error",
        duration: 2000,
      });
    } else {
      toast({
        title: "Error!",
        description: `Error updating profile.`,
        status: "error",
        duration: 2000,
      });
    }
  };

  const savePwChanges = async () => {
    const updatedFields = {};
    Object.keys(pwData).forEach((key) => {
      if (pwData[key] !== originalData[key]) {
        updatedFields[key] = pwData[key];
      }
    });
    const response = await adminUpdateUser(
      axiosPrivate,
      updatedFields,
      user._id
    );
    if (response.status === 200) {
      toast({
        title: "Success!",
        description: "Profile update saved.",
        status: "success",
        duration: 2000,
      });
      setNewPassword("");
      setConfirmNewPassword("");
    } else {
      toast({
        title: "Error!",
        description: `Error updating profile.`,
        status: "error",
        duration: 2000,
      });
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPwData((prev) => ({ ...prev, [name]: value }));
  };

  const validatePassword = (password) => {
    const requirementsRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$/;
    return requirementsRegex.test(password);
  };

  useEffect(() => {
    // Check if passwords match
    const passwordsDoMatch = newPassword === confirmNewPassword;
    setPasswordsMatch(passwordsDoMatch);

    // Validate new password requirements
    const isPasswordValid = validatePassword(newPassword);
    setPasswordValid(isPasswordValid);
  }, [newPassword, confirmNewPassword]);

  const handleReset = () => {
    setSelectedRole("");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmNewPassword("");
  };

  const handleDeleteUser = async () => {
    const response = await deleteUser(axiosPrivate, user._id);
    if (response.status === 200) {
      toast({
        title: "Success!",
        description: "Profile deleted.",
        status: "success",
        duration: 2000,
      });
      onUserUpdate();
      onClose();
    } else if (response.status === 400) {
      toast({
        title: "Error!",
        description: `User id not found.`,
        status: "error",
        duration: 2000,
      });
      console.log(response);
    } else {
      toast({
        title: "Error!",
        description: `Error updating profile.`,
        status: "error",
        duration: 2000,
      });
      console.log(response);
    }
  };

  const [roleCheckboxes, setRoleCheckboxes] = useState(() => {
    return {
      User: user?.roles?.User || false,
      Rep: user?.roles?.Rep || false,
      Support: user?.roles?.Support || false,
      Creative: user?.roles?.Creative || false,
      Billing: user?.roles?.Billing || false,
      Search: user?.roles?.Search || false,
      Social: user?.roles?.Social || false,
      Manager: user?.roles?.Manager || false,
      Admin: user?.roles?.Admin || false,
      SuperAdmin: user?.roles?.SuperAdmin || false,
      Dev: user?.roles?.SuperAdmin || false,
    };
  });

  const handleRoleCheckboxChange = (role) => {
    const canViewSection = hasRequiredRole(["Admin", "SuperAdmin"]);
    if (canViewSection) {
      setRoleCheckboxes((prev) => ({
        ...prev,
        [role]: !prev[role],
      }));
    } else {
      console.log("No perms");
    }
  };

  useEffect(() => {
    if (user) {
      setRoleCheckboxes({
        User: user.roles.User || false,
        Rep: user.roles.Rep || false,
        Support: user.roles.Support || false,
        Creative: user.roles.Creative || false,
        Billing: user.roles.Billing || false,
        Search: user.roles.Search || false,
        Social: user.roles.Social || false,
        Manager: user.roles.Manager || false,
        Admin: user.roles.Admin || false,
        SuperAdmin: user.roles.SuperAdmin || false,
        Dev: user.roles.SuperAdmin || false,
      });
      setUserData(user);
    }
  }, [user]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        motionPreset="slideInBottom"
        size="6xl"
        scrollBehavior={scrollBehavior}
      >
        <ModalOverlay />
        <ModalContent bg={bgColor}>
          <ModalHeader color={textColor}>User Account</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" w="100%">
              <Stack direction="column" spacing="24px">
                <HStack>
                  {Object.entries(rolesList).map(
                    ([role, { description, color }]) => (
                      <Badge key={role} colorScheme={color}>
                        {role}
                      </Badge>
                    )
                  )}
                </HStack>
                <Text color={textColor}>Select a role for the user:</Text>
                <Grid templateColumns="0.3fr auto 2fr" gap="2px">
                  {Object.entries(rolesList).map(
                    ([role, { description, color }]) => (
                      <React.Fragment key={role}>
                        <Box border="1px solid" borderColor="gray.400" p={2}>
                          <Badge colorScheme={color}>{role}</Badge>
                        </Box>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          border="1px solid"
                          borderColor="gray.400"
                          p={2}
                        >
                          <Checkbox
                            isChecked={roleCheckboxes[role]}
                            onChange={() => handleRoleCheckboxChange(role)}
                          />
                        </Box>
                        <Box border="1px solid" borderColor="gray.400" p={2}>
                          <Text textAlign="left">{description}</Text>
                        </Box>
                      </React.Fragment>
                    )
                  )}
                </Grid>
              </Stack>
            </Flex>
            <Text color={textColor} fontSize="lg" fontWeight="semibold" py={5}>
              Change Password
            </Text>
            <Stack direction="column" spacing="20px" w="100%">
              {/* <FormControl>
                <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">
                  Current Password
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    pr="4.5rem"
                    name="password"
                    type={show ? "text" : "password"}
                    placeholder="Current password"
                    value={currentPassword}
                    onChange={(e) => {
                      setCurrentPassword(e.target.value);
                      handlePasswordChange(e);
                    }}
                  />
                  <InputRightElement width="4.5rem">
                    <Button h="1.75rem" size="sm" onClick={handleClick}>
                      {show ? "Hide" : "Show"}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl> */}
              <FormControl isInvalid={!passwordsMatch}>
                <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">
                  New Password
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    pr="4.5rem"
                    name="newPassword"
                    type={show ? "text" : "password"}
                    placeholder="New password"
                    value={newPassword}
                    onChange={(e) => {
                      setNewPassword(e.target.value);
                      handlePasswordChange(e);
                    }}
                  />
                  <InputRightElement width="4.5rem">
                    <Button h="1.75rem" size="sm" onClick={handleClick}>
                      {show ? "Hide" : "Show"}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
              <FormControl isInvalid={!passwordsMatch}>
                <FormLabel fontWeight="semibold" fontSize="xs" mb="10px">
                  Confirm New Password
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    pr="4.5rem"
                    type={show ? "text" : "password"}
                    placeholder="Confirm New password"
                    value={confirmNewPassword}
                    onChange={(e) => {
                      setConfirmNewPassword(e.target.value);
                    }}
                  />
                  <InputRightElement width="4.5rem">
                    <Button h="1.75rem" size="sm" onClick={handleClick}>
                      {show ? "Hide" : "Show"}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                {!passwordValid && (
                  <FormErrorMessage>
                    Password does not meet requirements
                  </FormErrorMessage>
                )}
              </FormControl>
              <Flex direction="column">
                <Text color={textColor} fontWeight="bold" fontSize="lg" py={5}>
                  Password Requirements
                </Text>
                <Text color="gray.400" fontWeight="normal" fontSize="sm">
                  Please follow this guide for a strong password.
                </Text>
              </Flex>
              <Flex
                direction={{ sm: "column", lg: "row" }}
                justify="space-between"
                w="100%"
              >
                <Stack
                  direction="column"
                  spacing="6px"
                  mb={{ sm: "12px", lg: "0px" }}
                >
                  <Flex align="center">
                    <Icon
                      as={BsCircleFill}
                      w="6px"
                      h="6px"
                      color="gray.500"
                      me="6px"
                    />
                    <Text color="gray.500" fontWeight="normal" fontSize="xs">
                      One special characters
                    </Text>
                  </Flex>
                  <Flex align="center">
                    <Icon
                      as={BsCircleFill}
                      w="6px"
                      h="6px"
                      color="gray.500"
                      me="6px"
                    />
                    <Text color="gray.500" fontWeight="normal" fontSize="xs">
                      Min 6 characters
                    </Text>
                  </Flex>
                  <Flex align="center">
                    <Icon
                      as={BsCircleFill}
                      w="6px"
                      h="6px"
                      color="gray.500"
                      me="6px"
                    />
                    <Text color="gray.500" fontWeight="normal" fontSize="xs">
                      One number
                    </Text>
                  </Flex>
                </Stack>
                <Button
                  mt={4}
                  colorScheme="red"
                  type="submit"
                  isDisabled={!passwordsMatch || !passwordValid}
                  alignSelf={"flex-end"}
                  onClick={() => savePwChanges()}
                >
                  Change Password
                </Button>
              </Flex>
            </Stack>
            <Flex direction="column" pt={5}>
              <Text color={textColor} fontSize="lg" fontWeight="bold" mb="4px">
                Delete Account
              </Text>
              <Text color="gray.400" fontWeight="normal" fontSize="sm">
                Once you delete the account, there is no going back. Please be
                certain.
              </Text>
            </Flex>
            <Flex justify="space-between" align={"center"} w="100%">
              <Flex justify={"center"} align="center">
                <Switch
                  colorScheme="blue"
                  me="22px"
                  onChange={() => setConfirm(!confirm)}
                />
                <Flex direction="column">
                  <Text
                    fontSize="sm"
                    color={textColor}
                    mb="4px"
                    fontWeight="semibold"
                  >
                    Confirm
                  </Text>
                  <Text color="gray.400" fontWeight="normal" fontSize="xs">
                    I want to delete the account.
                  </Text>
                </Flex>
              </Flex>
              <Flex>
                <Button
                  variant="outline"
                  w="120px"
                  h="35px"
                  fontSize="10px"
                  me="14px"
                  onClick={() => {
                    handleAccountStatus();
                  }}
                >
                  {user?.isActive ? "DEACTIVATE" : "ACTIVATE"}
                </Button>
                <Button
                  colorScheme={"red"}
                  w="150px"
                  h="35px"
                  fontSize="10px"
                  isDisabled={!confirm}
                  onClick={() => {
                    handleDeleteUser();
                  }}
                >
                  DELETE ACCOUNT
                </Button>
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="ghost"
              mr={3}
              onClick={() => {
                saveChanges();
              }}
            >
              Save
            </Button>
            <Button
              colorScheme="blue"
              onClick={() => {
                handleReset();
                onClose();
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default UserModal;
